export default "__VITE_ASSET__BSGusOzu__"